export default "__VITE_ASSET__Nj3OqlWZ__"